import React from 'react';
import Dashboard from './dashboard/Dashboard';
import CompletnessWidget from './CompletnessWidget';

function Start() {
    return (
        <>
            <div className="col-sm-6">
                <Dashboard/> 
            </div>
            <div className="col-sm-6">
                <CompletnessWidget/> 
            </div>
        </>
    )
}

export default Start;